const createWhatsAppUrl = (number: string, message: string) => {
  if (!number || !number.match(/^\+[1-9]\d{10,14}$/) || !message) {
    return;
  }

  const whatsAppNumber = number.replace(/\D/g, "");

  return `https://wa.me/${whatsAppNumber}?text=${encodeURIComponent(
    message
  )}&app_absent=0`;
};

const shareToWhatsApp = (number: string, message: string) => {
  const whatsappUrl = createWhatsAppUrl(number, message);

  if (!whatsappUrl) {
    return;
  }

  window.open(whatsappUrl, "_blank");
};

export const share = {
  createWhatsAppUrl,
  whatsapp: shareToWhatsApp,
};
